<script setup lang="ts">
import {ref, useTemplateRef} from "vue";
import {ICellRendererParams} from "ag-grid-community";
import type {QPopupProxy} from "quasar";
import EditableGridHandler from "@/utils/presenters/EditableGridHandler.ts";

const props = defineProps<{ params: ICellRendererParams }>();
const fieldValue = props.params.value;
const qPopupProxyRef = useTemplateRef<QPopupProxy>("qPopupProxyRef")
const handler: EditableGridHandler = props.params["handler"]()
const columnId: string = props.params["columnId"]
const color = ref<string>()

const isDisabled = (): boolean => {
  return handler.presenter.isColumnDisabled(props.params.data.id, handler.gridId, columnId)
}

function showPopup() {
  if (!qPopupProxyRef.value)
    return;
  qPopupProxyRef.value.show()
}

function updateValue() {
  if (isDisabled())
    return;
  if (!color.value)
    return;
  if (!props.params)
    return;
  if (!props.params.setValue)
    return;
  props.params.setValue(color.value)
}
</script>

<template>
  <q-item dense class="tw-px-0 tw-w-full tw-h-full" @keydown="showPopup()">
    <q-item-section>
      <div class="tw-w-full tw-flex tw-justify-between">
        <span class="tw-overflow-hidden tw-size-5 tw-shrink-0 tw-rounded-sm" :style="{backgroundColor:fieldValue}"/>
        <span v-text="fieldValue"/>
        <q-avatar class="tw-cursor-pointer nama-avatar-hover" @click.stop="showPopup">
          <q-icon name="colorize" class="tw-cursor-pointer tw-text-[20px] tw-text-iconColor-light dark:tw-text-iconColor-dark"
                  :class="{'tw-text-iconColor-light  dark:tw-text-iconColor-dark' : !fieldValue}" :style="{fieldValue}">
            <q-popup-proxy cover @before-hide="updateValue" ref="qPopupProxyRef" class="tw-bg-transparent" transition-show="scale"
                           transition-hide="scale">
              <q-color v-model="color" format-model="rgb"
                       :readonly="isDisabled()"
                       class="tw-text-namaBlack tw-bg-white dark:tw-text-white dark:tw-bg-namaBackground-dim-dark"/>
            </q-popup-proxy>
          </q-icon>
        </q-avatar>
      </div>
    </q-item-section>
  </q-item>
</template>
